import React from 'react';

interface HotelImgProps {
    small?: boolean;
}

/**
 * Mayan Pyramid SVG icon for hotel/land-based tours
 */
function HotelImg({ small }: HotelImgProps) {
    const size = small ? 48 : 150;

    return (
        <svg
            width={size}
            height={size * 0.85}
            viewBox="0 0 100 85"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ display: 'block' }}
        >
            {/* Temple top structure */}
            <rect
                x="38"
                y="8"
                width="24"
                height="18"
                fill="white"
                stroke="var(--clr-primary, #102f63)"
                strokeWidth="2.5"
            />
            {/* Temple roof */}
            <rect
                x="42"
                y="4"
                width="16"
                height="6"
                fill="white"
                stroke="var(--clr-primary, #102f63)"
                strokeWidth="2.5"
            />
            {/* Temple doorway */}
            <path
                d="M45 26 L45 16 Q50 12 55 16 L55 26 Z"
                fill="var(--clr-primary, #102f63)"
            />

            {/* Pyramid tiers - 4 stepped levels */}
            <rect x="32" y="26" width="36" height="10" fill="white" stroke="var(--clr-primary, #102f63)" strokeWidth="2.5" />
            <rect x="24" y="36" width="52" height="10" fill="white" stroke="var(--clr-primary, #102f63)" strokeWidth="2.5" />
            <rect x="16" y="46" width="68" height="10" fill="white" stroke="var(--clr-primary, #102f63)" strokeWidth="2.5" />
            <rect x="8" y="56" width="84" height="12" fill="white" stroke="var(--clr-primary, #102f63)" strokeWidth="2.5" />
            {/* Base platform */}
            <rect x="4" y="68" width="92" height="10" fill="white" stroke="var(--clr-primary, #102f63)" strokeWidth="2.5" />

            {/* Central stairs */}
            <rect x="46" y="26" width="8" height="52" fill="var(--clr-primary, #102f63)" />

            {/* Stair step lines */}
            <line x1="46" y1="36" x2="54" y2="36" stroke="white" strokeWidth="1.5" />
            <line x1="46" y1="46" x2="54" y2="46" stroke="white" strokeWidth="1.5" />
            <line x1="46" y1="56" x2="54" y2="56" stroke="white" strokeWidth="1.5" />
            <line x1="46" y1="68" x2="54" y2="68" stroke="white" strokeWidth="1.5" />
        </svg>
    );
}

export default HotelImg;
